import React from 'react'

import RoomsList from '../components/roomsList'

function WaitingRoom({ rooms }) {
  return (
    <div className="waitingRoom">
      <h1>Waiting room</h1>
      <RoomsList rooms={rooms}/>
    </div>
  );
}

export default WaitingRoom;
